import { Component, OnInit, Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { BcModel } from '../../models/societe-linked/bc/bc.model';
import { BpModel } from '../../models/societe-linked/bp/bp.model';
import { SocieteLinkedModel } from '../../models/societe-linked/societe-linked.model';

@Injectable()
export class TrieTabService {

  sortData(sort: Sort, dataSource: BcModel[], matDataSource, pageIndex, pageSize): MatTableDataSource<BcModel> {
    if (!sort.active || sort.direction === '') {
      const data = this.loadPage(dataSource, pageIndex, pageSize);
      matDataSource = new MatTableDataSource(data);
      return matDataSource;
    }

    const data = dataSource.sort((a, b) => {

      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'societe':
          return this.compareString(`${a.societe.code}-${a.societe.libelle}`, `${b.societe.code}-${b.societe.libelle}`, isAsc);
        case 'Libelle':
          return this.compareString(a.libelleCa1, b.libelleCa1, isAsc);
        case 'Fournisseur':
          return this.compareString(a.libelleFourn, b.libelleFourn, isAsc);
        case 'NBc':
          return this.compareString(a.code, b.code, isAsc);
        case 'mntHt':
          return this.compare(a.ht, b.ht, isAsc);
        case 'CA1':
          return this.compareString(a.codeCa1, b.codeCa1, isAsc);
        case 'Site':
          return this.compareString(a.codeSite + '-' + a.libelleSite, b.codeSite + '-' + b.libelleSite, isAsc);
        case 'CodeAE':
          return this.compareString(a.chantier, b.chantier, isAsc);
        case 'Statut':
          return this.compareString(a.status, b.status, isAsc);
        case 'Date':
          return this.compareDate(a.dCreation, b.dCreation, isAsc);


        default:
          return 0;
      }
    });
    matDataSource = new MatTableDataSource<SocieteLinkedModel>(this.loadPage(data, pageIndex, pageSize));
    return matDataSource;
  }

  sortDataBp(sort: Sort, dataSource: BpModel[], matDataSource, pageIndex, pageSize): MatTableDataSource<BpModel> {
    if (!sort.active || sort.direction === '') {
      const data = this.loadPage(dataSource, pageIndex, pageSize);
      matDataSource = new MatTableDataSource(data);
      return matDataSource;
    }

    const data = dataSource.sort((a, b) => {

      const isAsc = sort.direction === 'asc';
      switch (sort.active) {

        case 'NBp':
          return this.compareString(a.code, b.code, isAsc);
        case 'NBc':
          return this.compareString(a.code, b.code, isAsc);
        case 'nFacture':
        return this.compareString(a.numFacture, b.numFacture, isAsc);
        case 'ttc':
          return this.compare(a.ttc, b.ttc, isAsc);
        case 'CA1':
          return this.compareString(a.codeCa1, b.codeCa1, isAsc);
        case 'Site':
          return this.compareString(a.codeSite + '-' + a.libelleSite, b.codeSite + '-' + b.libelleSite, isAsc);

        case 'Statut':
          return this.compareString(a.status, b.status, isAsc);
        case 'Date':
          return this.compareDate(a.dCreation, b.dCreation, isAsc);
        case 'dFacture':
          return this.compareDate(a.dCreation, b.dCreation, isAsc);


        default:
          return 0;
      }
    });
    matDataSource = new MatTableDataSource<SocieteLinkedModel>(this.loadPage(data, pageIndex, pageSize));
    return matDataSource;
  }

  loadPage(dataSource: any[], pageIndex, pageSize): any[] {
    return dataSource.slice(pageIndex * pageSize, (pageIndex * pageSize) + pageSize);
  }
  compareString(a: string, b: string, isAsc: boolean) {
    if (a !== undefined && a !== null) {
      return a.toString().localeCompare(b) * (isAsc ? 1 : -1);
    }
    return 0;
  }
  compareDate(a: Date, b: Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}


